module.exports = __webpack_public_path__ + "img/wildhorse-6-womens-trail-running-shoe-jJXN1F.dca0aea6.png";